import React, { FC, useContext } from "react";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";
import {
  CouponResponseCode,
  CustomPropertyKeys,
  TranslationKeys,
} from "../../../infrastructure/const";
import CheckUtils from "../../../utilities/check-utils";
import CartCouponCode from "../cart-coupon-code";
import TranslationManager from "../../../infrastructure/translation-manager";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationsUtils from "../../../utilities/translations-utils";

type Props = {
  properties: Record<string, any>;
  onUpdate: (value: string) => void;
  couponResponseCode: keyof typeof CouponResponseCode;
};

const PromoCode: FC<Props> = ({ properties, onUpdate, couponResponseCode }) => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const { isFeatureFlagEnabled } = useContext(ConfigurationContext);

  if (!isFeatureFlagEnabled("allowPromoCode")) {
    return null;
  }

  const promoCodeValue = properties[CustomPropertyKeys.Global.PromoCode];

  const promoCodeSelected =
    !CheckUtils.isNullObject(properties) &&
    !CheckUtils.isNullOrEmptyString(promoCodeValue);

  const promoCodeApplied =
    !CheckUtils.isNullObject(properties) &&
    promoCodeSelected &&
    !CheckUtils.isNullOrEmptyString(promoCodeValue);

  return (
    <CartCouponCode
      onValueChange={onUpdate}
      id="promo-code"
      selected={promoCodeSelected}
      value={promoCodeValue}
      applied={promoCodeApplied}
      label={translationManager.getTranslation(
        TranslationKeys.CART_PROMOCODE_LABEL
      )}
      placeholder={translationManager.getTranslation(
        TranslationKeys.CART_PROMOCODE_PLACEHOLDER
      )}
      buttonApplyLabel={translationManager.getTranslation(
        TranslationKeys.APPLY
      )}
      buttonCancelLabel={translationManager.getTranslation(
        TranslationKeys.CANCEL
      )}
      displayResponseMessage={true}
      responseMessage={
        couponResponseCode !== CouponResponseCode.NotApplied
          ? TranslationsUtils.getPromoCodeResponseTranslation(
              translationsContext,
              couponResponseCode
            )
          : ""
      }
      isErrorMessage={
        couponResponseCode !== CouponResponseCode.Success &&
        couponResponseCode !== CouponResponseCode.NotApplied
      }
      isMandatory={false}
    />
  );
};

export default PromoCode;
